import { render, staticRenderFns } from "./vendor-accounts.vue?vue&type=template&id=fa737a9e&scoped=true&"
import script from "./vendor-accounts.vue?vue&type=script&lang=js&"
export * from "./vendor-accounts.vue?vue&type=script&lang=js&"
import style0 from "./vendor-accounts.vue?vue&type=style&index=0&id=fa737a9e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa737a9e",
  null
  
)

export default component.exports